(function () {
  angular.module("pcmCommon")
    .filter("optionSummaryFilter", ["_", "UserProvider", "optionsUI", function (_, userProvider, optionsUI) {
      return function (route) {
        var summary = "";

        //summary += (route.options.routingType === 0) ? "Practical, " : "Shortest, ";
        summary += (_.find(optionsUI.vehicleType, {
          "value": route.options.vehicleType
        })).display + ", ";
        summary += (route.options.afSetIDs && route.options.afSetIDs !== "") ? "Use Route Modifiers, " : "",
        summary += (route.options.tollDiscourage) ? "Avoid Tolls, " : "";
        summary += (route.options.elevLimit) ? "Elev." + route.options.elevLimit + "," : "Elevation Discouraged, ";
        summary += (route.options.highwayOnly) ? "Highway Only, " : "Use Local Streets, ";
        summary += (route.options.ferryDiscourage) ? "Ferry Discouraged, " : "Ferry incl., ";
        summary += "Side of Street: ";
        summary += (_.find(optionsUI.sideOfStreetAdherence, {
          "value": route.options.sideOfStreetAdherence
        })).display + ", ";
        summary += (route.options.hubRouting) ? "Hub, " : "";
        summary += (route.options.useSites) ? "Site, " : "";
        summary += (route.options.classOverrides === 3) ? "National Network, " : "";
        summary += (route.options.classOverrides === 3) ? "53' Trailer, " : "";
        summary += (route.options.bordersOpen) ? "Borders Open, " : "Borders Closed, ";
        summary += (route.options.governorSpeedLimit) ? "Governor Speed Limit, " : "";
        summary += (route.options.hazMatType > 0) ? (_.find(optionsUI.hazmat, {
          "value": route.options.hazMatType
        })).display + ", " : "";
        summary += (route.options.overrideRestrict) ? "Override, " : "";
        summary += (_.find(optionsUI.routingType, {
          "value": route.options.routingType
        })).display + " Routing Type, ";
        summary += (route.options.inclFerryDist) ? "Ferry Dist. incl, " : "";

        return summary.substr(0, summary.length - 2);
      };
    }]);

  angular.module("pcmCommon")
    .filter("vehicleSummaryFilter", ["$filter", function ($filter) {
      return function (route) {
        var summary = "Weight: ";

        if (route.options.trkUnits === 0) {
          summary += $filter("number")(route.options.trkWeight) + "lbs | Height: ";
          summary += route.options.trkHeight + " | Length: ";
          summary += route.options.trkLength + " | Width: ";
          summary += route.options.trkWidth;
        } else {
          summary += $filter("number")(route.options.trkWeight) + "kgs | Height: ";
          summary += route.options.trkHeight + "m | Length: ";
          summary += route.options.trkLength + "m | Width: ";
          summary += route.options.trkWidth;
        }

        summary += " | Axles: " + route.options.trkAxles;

        return summary;
      };
    }]);

  angular.module("pcmCommon")
    .filter("tollCostSummaryFilter",["_", "optionsUI", function(_, optionsUI) {
      return function(amount, currencyType) {
        var curr = _.find(_.union(optionsUI.tollCurrency, optionsUI.tollCurrencyEU),{value: currencyType});
        return (curr.isPrefix) ? curr.symbol + amount : amount + " " + curr.symbol;
      };
    }]);
})();



// WEBPACK FOOTER //
// ./app/pcm-common/filters.module.js